export default class Events {
  static eventHandlers: Map<string, ((e: any) => void)[]> = new Map();

  static on<T>(name: string, handler: (e: T) => void): void {
    if (!Events.eventHandlers.has(name)) {
      Events.eventHandlers.set(name, []);
    }
    Events.eventHandlers.get(name)?.push(handler);
  }

  static fire<T>(name: string, data: T): void {
    const handlers = Events.eventHandlers.get(name);
    if (handlers == null) return;
    handlers.forEach((f) => {
      const fCast = <(e: T) => void>f;
      fCast(data);
    });
  }
}
